import { render, staticRenderFns } from "./StuAnalysis.vue?vue&type=template&id=74f66457&scoped=true&"
import script from "./StuAnalysis.vue?vue&type=script&lang=js&"
export * from "./StuAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./StuAnalysis.vue?vue&type=style&index=0&id=74f66457&prod&lang=scss&scoped=true&"
import style1 from "./StuAnalysis.vue?vue&type=style&index=1&id=74f66457&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f66457",
  null
  
)

export default component.exports